import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import api from "../../utils/Api";

function RegisterForm() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [errorsEmpresa, setErrorsEmpresa] = useState({});
  const [errorsUsuario, setErrorsUsuario] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [empresaData, setEmpresaData] = useState({
    nombre_fiscal: "",
    cif: "",
    direccion: "",
    telefono: "",
    email: "",
    logo: null,
  });

  const [usuarioData, setUsuarioData] = useState({
    dni: "",
    nombre: "",
    apellidos: "",
    email: "",
    telefono: "",
    rol: "admin",
    estado: "activo",
    password: "",
    password_confirmation: "",
  });

  // Validación empresa
  const validateFormEmpresa = () => {
    const errors = {};
    // Expresión regular para el nombre fiscal hay que tener en cuenta el tema de los puntos porque hay empresas en las que tenemos
    // S.L
    if(!empresaData.nombre_fiscal.trim()) errors.nombre_fiscal = "El campo Empresa es obligatorio.";
    else if(!/^[a-zA-Z\s]+$/.test(empresaData.nombre_fiscal)) errors.nombre_fiscal = "El nombre de la empresa no es válido.";

    // CAMPO CIF EN ESTE CASO SI ESTÁ BIEN
    if(!empresaData.cif.trim()) errors.cif = "El campo CIF es obligatorio.";
    else if(!/^[A-Z0-9]+$/.test(empresaData.cif)) errors.cif = "El CIF no es válido.";

    // PARA ESTE TEMA DE DIRECCIÓN DEBERÍA PODER PERMITIR POR EJEMPLO C/
    if(!empresaData.direccion.trim()) errors.direccion = "El campo dirección es obligatorio.";
    else if(!/^[a-zA-Z0-9\s,.-]+$/.test(empresaData.direccion)) errors.direccion = "La dirección no es válida.";

    // PARA EL TEMA DEL TELÉFONO
    if(!empresaData.telefono.trim()) errors.telefono = "El campo teléfono es obligatorio.";
    else if(!/^\d{9}$/.test(empresaData.telefono)) errors.telefono = "El teléfono debe tener 9 dígitos.";

    // EMAIL EN ESTE POR EL MOMENTO ESTÁ BIEN
    if(!empresaData.email.trim()) errors.email = "El campo email es obligatorio.";
    else if(!/\S+@\S+\.\S+/.test(empresaData.email)) errors.email = "El email no es válido.";

    return errors;
  }

  // Validación usuario
  const validateFormUsuario = () => {
    const errors = {};
    // Campo de dni actualmente está bien porque la expresión regular tiene 8 digitos y una letra de la A - Z
    if(!usuarioData.dni.trim()) errors.dni = "El campo DNI es obligatorio.";
    else if(!/^\d{8}[A-Z]$/.test(usuarioData.dni)) errors.dni = "El DNI no es válido.";

    // Campo de nombre añadir el tema de las tildes, actualmente solo entra con la expresión regular con las letras sin tildes ni nada. Ej: MARTIN GONZALEZ Y NO MARTÍN GONZÁLEZ
    if(!usuarioData.nombre.trim()) errors.nombre = "El campo nombre es obligatorio.";
    else if(!/^[a-zA-Z\s]+$/.test(usuarioData.nombre)) errors.nombre = "El nombre no es válido.";

    // Campo de apellidos añadir el tema de las tildes
    if(!usuarioData.apellidos.trim()) errors.apellidos = "El campo apellidos es obligatorio.";
    else if(!/^[a-zA-Z\s]+$/.test(usuarioData.apellidos)) errors.apellidos = "Los apellidos no son válidos.";

    // Campo email mirar la validación para que esté de forma correcta todo al igual que 
    if(!usuarioData.email.trim()) errors.email = "El campo email es obligatorio.";
    else if(!/\S+@\S+\.\S+/.test(usuarioData.email)) errors.email = "El email no es válido.";

    // CAMPO DE TELÉFONO MIRAR PARA PONER EN EL CASO DE QUE SEA DE OTRO PAIS AÑADIR EL +34
    if(!usuarioData.telefono.trim()) errors.telefono = "El campo teléfono es obligatorio.";
    else if(!/^\d{9}$/.test(usuarioData.telefono)) errors.telefono = "El teléfono debe tener 9 dígitos.";

    // Campo de contraseña hay que añadir la validación de que sean minimo 8 caracteres, una mayuscula, algún signo o algo para que se pueda
    // tener un nivel minimo de seguridad...
    if(!usuarioData.password.trim()) errors.password = "El campo contraseña es obligatorio.";
    else if(usuarioData.password.length < 8) errors.password = "La contraseña debe tener al menos 8 caracteres.";

    // Para que este campo se valida debe ser igual al otro campo de arriba.
    if(usuarioData.password !== usuarioData.password_confirmation) errors.password_confirmation = "Las contraseñas no coinciden.";

    return errors;
  }

  // Paso 1: validar empresa
  const handleSubmitEmpresa = (e) => {
    e.preventDefault();
    const formErrors = validateFormEmpresa();
    setErrorsEmpresa(formErrors);
    if(Object.keys(formErrors).length > 0) return;
    // Si el formulario no tiene errores pasa al paso 2
    setStep(2);
  }

  // Paso 2: registrar usuario + empresa
  const handleSubmitUsuario = async (e) => {
    e.preventDefault();
    const formErrors = validateFormUsuario();
    setErrorsUsuario(formErrors);
    if(Object.keys(formErrors).length > 0) return;

    setLoading(true);

    try {
      const formData = new FormData();
      // Empresa
      formData.append("nombre_fiscal", empresaData.nombre_fiscal);
      formData.append("cif", empresaData.cif);
      formData.append("direccion", empresaData.direccion);
      formData.append("telefono_empresa", empresaData.telefono);
      formData.append("email_empresa", empresaData.email);
      if(empresaData.logo) formData.append("logo", empresaData.logo);

      // Usuario
      formData.append("dni", usuarioData.dni);
      formData.append("nombre", usuarioData.nombre);
      formData.append("apellidos", usuarioData.apellidos);
      formData.append("email_usuario", usuarioData.email);
      formData.append("telefono_usuario", usuarioData.telefono);
      formData.append("rol", usuarioData.rol);
      formData.append("estado", usuarioData.estado);
      formData.append("password", usuarioData.password);
      formData.append("password_confirmation", usuarioData.password_confirmation);

      await api.post("/register", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setSuccessMessage("¡Registro completado correctamente! Redirigiendo al login...");
      setTimeout(() => navigate("/"), 2500);
    } catch (err) {
      if(err.response?.data?.errors){
        setErrorsEmpresa(err.response.data.errors.nombre_fiscal ? { nombre_fiscal: err.response.data.errors.nombre_fiscal[0] } : {});
        setErrorsUsuario({
          dni: err.response.data.errors.dni ? err.response.data.errors.dni[0] : undefined,
          email: err.response.data.errors.email_usuario ? err.response.data.errors.email_usuario[0] : undefined
        });
      } else {
        setSuccessMessage("Error al registrar. Intente nuevamente.");
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="container p-5">
      <h2 className="text-center fw-semibold" style={{ color: "#2C2C2C" }}>
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            fill="#FF7A00"
            className="bi bi-clock-history me-2 align-middle"
            viewBox="0 0 16 16"
          >
            <path d="M8.515 1.019A7 7 0 1 0 15 8a.5.5 0 0 0-1 0 6 6 0 1 1-5.485-6.981z" />
            <path d="M7.5 3a.5.5 0 0 1 .5.5v4.25l3.15 1.85a.5.5 0 1 1-.5.866L7.5 8.5V3.5A.5.5 0 0 1 7.5 3z" />
          </svg>
            Turnora
      </h2>
      <div className="row justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
        <div className="col-md-8 col-lg-6">
          {successMessage && (
            <div className="alert alert-success text-center">{successMessage}</div>
          )}

          {/* Paso 1: Empresa */}
          {step === 1 && (
            <form onSubmit={handleSubmitEmpresa} className="p-5 border rounded shadow-sm bg-white">
              <h2 className="mb-3 text-center fs-4">Registro de Empresa</h2>
              <div className="row mb-2">
                <div className="col-12 col-md-6 mb-2">
                  <label htmlFor="nombre_fiscal" className="form-label" style={{ fontSize: "14px" }}>Empresa:</label>
                  <input type="text" id="nombre_fiscal" className={`form-control ${errorsEmpresa.nombre_fiscal ? "is-invalid" : ""}`} value={empresaData.nombre_fiscal} onChange={(e)=>setEmpresaData({...empresaData,nombre_fiscal:e.target.value}) } placeholder="Nombre de la empresa"/>
                  {errorsEmpresa.nombre_fiscal && <div className="invalid-feedback">{errorsEmpresa.nombre_fiscal}</div>}
                </div>
                <div className="col-12 col-md-6 mb-2">
                  <label htmlFor="cif" className="form-label" style={{ fontSize: "14px" }}>CIF:</label>
                  <input type="text" id="cif" className={`form-control ${errorsEmpresa.cif ? "is-invalid" : ""}`} value={empresaData.cif} onChange={(e)=>setEmpresaData({...empresaData,cif:e.target.value})} placeholder="CIF de la empresa"/>
                  {errorsEmpresa.cif && <div className="invalid-feedback">{errorsEmpresa.cif}</div>}
                  
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-12 col-md-6 mb-2">
                  <label htmlFor="direccion" className="form-label" style={{ fontSize: "14px" }}>Dirección:</label>
                  <input type="text" id="direccion" className={`form-control ${errorsEmpresa.direccion ? "is-invalid" : ""}`} value={empresaData.direccion} onChange={(e)=>setEmpresaData({...empresaData,direccion:e.target.value})} placeholder="Dirección de la empresa"/>
                  {errorsEmpresa.direccion && <div className="invalid-feedback">{errorsEmpresa.direccion}</div>}
                </div>
                <div className="col-12 col-md-6 mb-2">
                  <label htmlFor="telefono" className="form-label" style={{ fontSize: "14px" }}>Teléfono:</label>
                  <input type="tel" id="telefono" className={`form-control ${errorsEmpresa.telefono ? "is-invalid" : ""}`} value={empresaData.telefono} onChange={(e)=>setEmpresaData({...empresaData,telefono:e.target.value})} placeholder="Teléfono de contacto"/>
                  {errorsEmpresa.telefono && <div className="invalid-feedback">{errorsEmpresa.telefono}</div>}
                </div>
              </div>

              <div className="mb-2">
                <label htmlFor="email" className="form-label" style={{ fontSize: "14px" }}>Email:</label>
                <input type="email" id="email" className={`form-control ${errorsEmpresa.email ? "is-invalid" : ""}`} value={empresaData.email} onChange={(e)=>setEmpresaData({...empresaData,email:e.target.value})} placeholder="Email"/>
                {errorsEmpresa.email && <div className="invalid-feedback">{errorsEmpresa.email}</div>}
              </div>

              <div className="mb-2">
                <label htmlFor="logo" className="form-label" style={{ fontSize: "14px" }}>Logo:</label>
                <input type="file" id="logo" className="form-control" accept="image/*" onChange={(e)=>setEmpresaData({...empresaData,logo:e.target.files[0]})}/>
              </div>

              <div className="d-grid mt-3">
                <button type="submit" className="btn btn-primary" style={{backgroundColor:"#FF7A00",color:"#fff",border:"none"}}>Siguiente</button>
              </div>

              <div className="text-center mt-3" style={{ fontSize: "14px" }}>
                ¿Ya tienes cuenta? <Link to="/" style={{color:"#FF7A00", fontWeight:"500", textDecoration:"none"}}>Inicia sesión</Link>
              </div>
            </form>
          )}

          {/* Paso 2: Usuario */}
          {step === 2 && (
            <form onSubmit={handleSubmitUsuario} className="p-4 border rounded shadow-sm bg-white">
              <h2 className="mb-3 text-center fs-4">Registro de Usuario</h2>

              <div className="row mb-2">
                <div className="col-12 col-md-6 mb-2">
                  <label htmlFor="nombre" className="form-label" style={{ fontSize: "14px" }}>Nombre:</label>
                  <input type="text" id="nombre" className={`form-control ${errorsUsuario.nombre ? "is-invalid" : ""}`} value={usuarioData.nombre} onChange={(e)=>setUsuarioData({...usuarioData,nombre:e.target.value})} placeholder="Nombre"/>
                  {errorsUsuario.nombre && <div className="invalid-feedback">{errorsUsuario.nombre}</div>}
                </div>
                <div className="col-12 col-md-6 mb-2">
                  <label htmlFor="apellidos" className="form-label" style={{ fontSize: "14px" }}>Apellidos:</label>
                  <input type="text" id="apellidos" className={`form-control ${errorsUsuario.apellidos ? "is-invalid" : ""}`} value={usuarioData.apellidos} onChange={(e)=>setUsuarioData({...usuarioData,apellidos:e.target.value})} placeholder="Apellidos"/>
                  {errorsUsuario.apellidos && <div className="invalid-feedback">{errorsUsuario.apellidos}</div>}
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-12 col-md-6 mb-2">
                  <label htmlFor="dni" className="form-label" style={{ fontSize: "14px" }}>DNI:</label>
                  <input type="text" id="dni" className={`form-control ${errorsUsuario.dni ? "is-invalid" : ""}`} value={usuarioData.dni} onChange={(e)=>setUsuarioData({...usuarioData,dni:e.target.value})} placeholder="DNI"/>
                  {errorsUsuario.dni && <div className="invalid-feedback">{errorsUsuario.dni}</div>}
                </div>
                <div className="col-12 col-md-6 mb-2">
                  <label htmlFor="telefono" className="form-label" style={{ fontSize: "14px" }}>Teléfono:</label>
                  <input type="tel" id="telefono" className={`form-control ${errorsUsuario.telefono ? "is-invalid" : ""}`} value={usuarioData.telefono} onChange={(e)=>setUsuarioData({...usuarioData,telefono:e.target.value})} placeholder="Teléfono"/>
                  {errorsUsuario.telefono && <div className="invalid-feedback">{errorsUsuario.telefono}</div>}
                </div>
              </div>

              <div className="mb-2">
                <label htmlFor="email" className="form-label" style={{ fontSize: "14px" }}>Email:</label>
                <input type="email" id="email" className={`form-control ${errorsUsuario.email ? "is-invalid" : ""}`} value={usuarioData.email} onChange={(e)=>setUsuarioData({...usuarioData,email:e.target.value})} placeholder="Email"/>
                {errorsUsuario.email && <div className="invalid-feedback">{errorsUsuario.email}</div>}
              </div>

              <div className="row mb-2">
                <div className="col-12 col-md-6 mb-2">
                  <label htmlFor="password" className="form-label" style={{ fontSize: "14px" }}>Contraseña:</label>
                  <div className="input-group">
                    <input type={showPassword ? "text" : "password"} id="password" className={`form-control ${errorsUsuario.password ? "is-invalid" : ""}`} value={usuarioData.password} onChange={(e)=>setUsuarioData({...usuarioData,password:e.target.value})} placeholder="Contraseña"/>
                    <button type="button" className="btn btn-outline-secondary" onClick={()=>setShowPassword(!showPassword)}>
                      <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                    </button>
                  </div>
                  {errorsUsuario.password && <div className="invalid-feedback">{errorsUsuario.password}</div>}
                </div>
                <div className="col-12 col-md-6 mb-2">
                  <label htmlFor="password_confirmation" className="form-label" style={{ fontSize: "14px" }}>Confirmar Contraseña:</label>
                  <div className="input-group">
                    <input type={showPassword ? "text" : "password"} id="password_confirmation" className={`form-control ${errorsUsuario.password_confirmation ? "is-invalid" : ""}`} value={usuarioData.password_confirmation} onChange={(e)=>setUsuarioData({...usuarioData,password_confirmation:e.target.value})} placeholder="Repite la contraseña"/>
                    <button type="button" className="btn btn-outline-secondary" onClick={()=>setShowPassword(!showPassword)}>
                      <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                    </button>
                  </div>
                  {errorsUsuario.password_confirmation && <div className="invalid-feedback">{errorsUsuario.password_confirmation}</div>}
                </div>
              </div>

              <div className="d-flex justify-content-between">
                <button type="button" className="btn btn-secondary" onClick={()=>setStep(1)}>Volver</button>
                <button type="submit" className="btn btn-primary" style={{backgroundColor:"#FF7A00",color:"#fff",border:"none"}}>
                  {loading ? "Registrando..." : "Registrar Usuario"}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default RegisterForm;
